/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{position:relative;display:flex;justify-content:space-between;top:6px}.container-child[_ngcontent-%COMP%]{position:relative;width:50%;height:20px}.button-icon[_ngcontent-%COMP%]{top:-8px}.mat-datepicker-toggle[_ngcontent-%COMP%]{position:absolute;left:-3px}input.mat-input-element[_ngcontent-%COMP%]{position:relative;width:70%;left:42px;top:0}input.datetime-time-input.mat-input-element[_ngcontent-%COMP%]{position:absolute;left:42px;top:0}\n/*# sourceMappingURL=date-time-field.component.css.map*/"];
export { styles as styles };
